import React from 'react'
import cx from 'classnames'
import { links } from 'common/helpers'

import FooterCopy from 'compositions/FooterCopy/FooterCopy'
import { WidthContainer } from 'components/_new/layout'
import SkipContent from 'components/_new/ada/SkipContent/SkipContent'
import { Href } from 'components/_new/controls'
import { Logo } from 'components/_new/ui'

import s from './WithoutHeaderLayout.scss'


const WithoutHeaderLayout = (props) => {
  const { children, logoLink, logoCenter, withLogo = true, withFooter, withCopyrightFooter, onLogoClick } = props

  const isLinkToLanding = [ links.home, links.homeMen ].includes(logoLink)

  const logoLinkProps = isLinkToLanding ? {
    href: logoLink,
  } : {
    to: logoLink,
  }

  const rootClassName = cx(s.wrapper, {
    [s.bottomPadding]: !withFooter && !withCopyrightFooter,
  })

  const logoClassName = cx(s.logo, {
    [s.logoCenter]: logoCenter,
  })

  return (
    <div className={rootClassName}>
      <SkipContent contentId="mainContent" />
      {
        withLogo && (
          <WidthContainer className={s.header}>
            <Href
              className={logoClassName}
              dataTestId="headerLogo"
              onClick={onLogoClick}
              {...logoLinkProps}
            >
              <Logo dark />
            </Href>
          </WidthContainer>
        )
      }
      <div className={s.contentContainer} id="mainContent" role="main">
        {children}
      </div>
      <FooterCopy />
    </div>
  )
}


export default WithoutHeaderLayout
